import dayjs, { Dayjs } from 'dayjs';
import { formatDateTime } from 'translations/formatters';
import { t } from 'translations/t';

export const formatWorkoutTimestamp = ({
  start_time,
  end_time,
}: {
  start_time: number;
  end_time: number;
}) => {
  const workoutStart = dayjs.unix(start_time);
  const workoutEnd = dayjs.unix(end_time);
  const now = dayjs();
  const yesterday = dayjs().subtract(1, 'day');

  if (now.isSame(workoutEnd, 'day')) {
    return workoutEnd.fromNow();
  }

  if (yesterday.isSame(workoutStart, 'day')) {
    return t('web.relativeDate.yesterday', {
      time: formatDateTime(workoutStart.toDate(), { hour: 'numeric', minute: '2-digit' }),
    });
  }

  return formatDateTime(workoutStart.toDate(), {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
};

export const getRelativeDate = (date: Dayjs) => {
  const now = dayjs();
  const yesterday = dayjs().subtract(1, 'day');

  if (now.isSame(date, 'day')) {
    return date.fromNow();
  }

  if (yesterday.isSame(date, 'day')) {
    return t('web.relativeDate.yesterday', {
      time: formatDateTime(date.toDate(), { hour: 'numeric', minute: '2-digit' }),
    });
  }

  return formatDateTime(date.toDate(), {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
};
